import { useEffect } from "react";
import $ from "jquery";
export default function PaymentsFailureModal({
  setShowPaymentFailureModal,
  androidPaymentQRLink,
}) {
  useEffect(() => {
    $("#payment-failure").modal("show");
  });
  return (
    <section>
      <div
        class="modal"
        data-backdrop="static"
        data-keyboard="false"
        id="payment-failure"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered payment_failure_modal" role="document">
          <div
            class="modal-content"
          >
            <div>
              <span
                className="close_btn"
                onClick={(e) => {
                  setShowPaymentFailureModal(false);
                  $("#payment-failure").modal("hide");
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18 6L6 18"
                    stroke="#A9A9AC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 6L18 18"
                    stroke="#A9A9AC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
            <div class="modal-body" style={{ paddingBottom: "30px" }}>
              <img
              className="payment_failure_modal_header_img"
                src="https://media.geeksforgeeks.org/img-practice/prod/payment_gateway/332211222221/Web/Popup/payment-failure_1692937098.png"
                alt=""
              />
              <div className="payment_failure_modal_header">
                Unable to complete your payment?
              </div>
              <div className="payment_fail_description">
                No worries! Try our app for a hassle-free payment experience
              </div>
              <div className="payment_fail_meta">
                Scan the QR code to pay
              </div>
              <div className="payment_failure_qr_container">
                <img
                  className="payment_failure_qr_modal"
                  src={androidPaymentQRLink}
                  alt="GFG Google Play Link"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}